import React, { useState, useEffect } from "react";
import Swiper from "../Components/Swiper";
import axios from "../Config/axios";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ReactPlayer from "react-player";

function Live() {
  const [isMobile, setIsMobile] = useState(false);
  const [liveData, setLiveData] = useState([]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.outerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    axios
      .get("live/get")
      .then((res) => {
        let { code } = res.data;
        if (code === 200) {
          setLiveData(res?.data?.data?.live);
        } else if (code === 400) {
          setLiveData(res?.data?.data?.live);
        }
      })
      .catch(() => {});
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className={`background ${isMobile ? "header-placement" : ""}`}>
      {!isMobile && <Swiper />}
      <Navbar activeLink="live" />
      <div className="wrapper">
        <div className="container table-responsive row mt-4">
          {liveData
            ? liveData?.map((item, index) => (
                <div key={index} className=" mb-4">
                  <div className="mb-2">
                    <a
                      href={item?.live_url}
                      target="_blank"
                      className="fw-bold text-dark fs-4 mb-2"
                    >
                      {item?.title}
                    </a>
                  </div>
                  <div className="player-wrapper">
                    <ReactPlayer
                      className="react-player"
                      url={item?.live_url}
                      width="100%"
                      style={{ minHeight: 500, height: "100%" }}
                    />
                  </div>
                </div>
              ))
            : null}
        </div>
        <Footer isMobile={isMobile} />
      </div>
    </div>
  );
}

export default Live;
